import { render, staticRenderFns } from "./ChartDonutNew.vue?vue&type=template&id=d968d222&scoped=true"
import script from "./ChartDonutNew.vue?vue&type=script&lang=js"
export * from "./ChartDonutNew.vue?vue&type=script&lang=js"
import style0 from "./ChartDonutNew.vue?vue&type=style&index=0&id=d968d222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d968d222",
  null
  
)

export default component.exports